import React, { useState } from "react";
import { InventoryPage } from "../../components/inventory/Create/InventoryPage";
import CreateInventoryModal from "../../components/Sales/invoice/inventory/CreateInventoryModal";
import { IInventory, ItemInput } from "../../@types";
import { useNavigate } from "react-router-dom";
import AddInventory from "../../components/Invoice/sections/LineItemsSection/AddInventory";
import ProductOptions from "../../components/Invoice/sections/LineItemsSection/ProductOptions";
import ProductVariants from "../../components/Invoice/sections/LineItemsSection/ProductVariants";
import ViewSelectItems from "../../components/Invoice/sections/LineItemsSection/ViewSelectItems";
import { VariationItem } from "../../@types/inventory";
import { InventoryFormData } from "../../components/Invoice/sections/LineItemsSection/ShowSelectedItem";
import { useTour } from "../../context/TourContext";
import { useUserStore } from "../../state";
import { useCreateInventoryTourGuide } from "../../components/tourGide/useCreateInventoryTourGuide";
import { useIsMobile } from "../../components/tourGide/useIsMobile";

export interface Option {
  name: string;
  type: string[];
}

const CreateInventoryPage = () => {
  const [showCreateInventory, setShowCreateInventory] = React.useState(false);
  const [currentView, setCurrentView] = useState<
    | "selectItem"
    | "addInventory"
    | "productOptions"
    | "productVariants"
    | "viewSelectItems"
    | "showSelectedItem"
    | null
  >("addInventory");
  const [options, setOptions] = useState<Option[]>([{ name: "", type: [""] }]);
  const navigate = useNavigate();
  const handleCreateSuccess = (newItem: ItemInput) => {
    navigate(-1);
    setShowCreateInventory(false);
  };

  const { registerSteps, startTour } = useTour();
  const { user } = useUserStore();
  const isMobile = useIsMobile();
  const { createInventoryTourGuide } = useCreateInventoryTourGuide();

  registerSteps("createInventory", [...createInventoryTourGuide]);

  React.useEffect(() => {
    if (user?.prefs?.isFirstInventory && !isMobile) {
      startTour("createInventory");
    }
  }, [registerSteps]);

  const handleBackToNone = () => setCurrentView(null);
  const handleOpenAddInventory = () => setCurrentView("addInventory");
  const handleOpenProductOptions = () => setCurrentView("productOptions");
  const handleOpenVariants = () => setCurrentView("productVariants");
  const [savedVariants, setSavedVariants] = useState<VariationItem[]>([]);
  const [selectedInventory, setSelectedInventory] = useState<IInventory | null>(
    null,
  );
  const [editInventory, setEditInventory] = useState<InventoryFormData | null>(
    null,
  );
  const [variationList, setVariationList] = useState<VariationItem[]>([]);
  const [quantities, setQuantities] = useState<{ [key: string]: string }>({});
  const setSelectedInventoryAndQuantities = (
    inventory: any,
    updatedQuantities: { [key: string]: string },
  ) => {
    const total = inventory.quantity * inventory.rate;
    const updatedInventory = { ...inventory, total };
    setSelectedInventory(updatedInventory);
    setQuantities(updatedQuantities);
  };

  const closeModal = () => {
    setCurrentView(null);

    setQuantities((prevQuantities) => {
      const updatedQuantities = { ...prevQuantities };

      return updatedQuantities;
    });
  };

  const handleSave = (savedVariants: VariationItem[]) => {
    setSavedVariants([...savedVariants]);
    setCurrentView("addInventory");
  };

  const closeProductOptions = () => {
    setCurrentView(null);
  };
  const variations: any[] = [];
  return (
    <div>
      {/* <InventoryPage /> */}
      <div className="hidden md:block">
        <CreateInventoryModal
          show={showCreateInventory}
          setShowCreateInventory={setShowCreateInventory}
          onCreateSuccess={handleCreateSuccess}
          isInventory={true}
        />
      </div>
      <div className="block md:hidden">
        {currentView === "addInventory" && (
          <AddInventory
            setIsOpen={handleBackToNone}
            setOpenProductOptions={handleOpenProductOptions}
            variants={savedVariants}
            setCurrentView={setCurrentView}
            setVariationList={setSavedVariants}
            variationList={savedVariants}
            onInventoryAdded={(inventory) =>
              setSelectedInventoryAndQuantities(inventory, {})
            }
            goBack={() => navigate(-1)}
          />
        )}

        {currentView === "productOptions" && (
          <ProductOptions
            options={options}
            setOptions={setOptions}
            handleOpenVariants={handleOpenVariants}
            setCurrentView={setCurrentView}
            variations={variations}
            setVariationList={setVariationList}
            closeProductOptions={closeProductOptions}
            isInventory={true}
          />
        )}

        {currentView === "productVariants" && (
          <ProductVariants
            options={options}
            setOptions={setOptions}
            setCurrentView={setCurrentView}
            onSave={handleSave}
          />
        )}
        {currentView === "viewSelectItems" && (
          <ViewSelectItems
            selectedInventory={selectedInventory}
            quantities={quantities}
            closeModal={closeModal}
          />
        )}
      </div>
    </div>
  );
};

export { CreateInventoryPage };
